import omit from 'lodash/fp/omit';
import { UserProfile as Profile } from 'oidc-client-ts';
import { UserProfile } from './loginSlice';

const stripSnakeProps = omit(['family_name', 'given_name']);

// TODO: Depending on your client subscriptions you may want to map
//       additional properties from the OAuth profile
export const mapUserProfile = (profile: Profile): UserProfile => ({
    sub: profile.sub,
    // azp: profile.azp,
    // givenName: profile.given_name,
    // familyName: profile.family_name,
    name: profile.name,
    // locale: profile.locale,
    email: profile.email,
    ...stripSnakeProps(profile),
});
// ID Token Claims
// iss: The issuer claim represents the issuer of the token.
// sub: The subject claim represents the subject of the token, which is typically the user ID.
// aud: The audience claim represents the audience for which the token is intended.
// exp: The expiration time claim denotes the time when the token expires.
// iat: The issued at claim represents the time when the token was issued.
// auth_time: The authentication time claim denotes the time when the user authenticated.
// nonce: The nonce claim is used to prevent replay attacks.
// acr: The authentication context class reference claim represents the authentication context class reference.
// amr: The authentication methods references claim contains the authentication methods used.
// azp: The authorized party claim represents the authorized party for which the token is intended.

// aud: "b47264dc-06d5-4a7f-b7a0-10c48d5bd0ad"
// email: "markus.ewers-ext@man.eu"
// exp: 1763566207
// iat: 1763562307
// idp: "https://sts.windows.net/ccc63daa-d84b-4abd-98fd-4eeb839de273/"
// iss: "https://login.microsoftonline.com/7e4c72b8-86d8-4e3a-90d8-4f7b7b2513c2/v2.0"
// name: "Markus Ewers"
// oid: "3d2f6b70-3dfa-447f-827e-44484dfd5722"
// preferred_username: "markus.ewers-ext@man.eu"
// rh: "1.AXMAuHJMftiGOk6Q2E97eyUTwtxkcrTVBn9Kt6AQxI1b0K1zAFNzAA."
// sid: "00aa78b9-3edd-3634-7646-28512c62fead"
// sub: "Ddjg2XfF8P2E9DTvd7PNE4tOQMgFkpSajs33pzyNW64"
// tid: "7e4c72b8-86d8-4e3a-90d8-4f7b7b2513c2"
// uti: "k-ed8W26akm-G_ElmacTAA"
// ver: "2.0"

// Standard Identity Claims
// In addition to the OAuth 2.0 claims, there are standard identity claims that provide specific
// information about the user's profile and attributes. These claims offer a standardized way of
// conveying essential identity-related data. Let's explore some of the commonly used standard
// identity claims:
//
// name: The name claim represents the user's full name.
// given_name: This claim contains the user's given or first name.
// family_name: The family name claim represents the user's last or family name.
// middle_name: The middle name claim carries the user's middle name, if applicable.
// nickname: The nickname claim contains a short name or alias used by the user.
// preferred_username: This claim represents the user's preferred username or handle.
// profile: The profile claim points to a URL that provides additional profile information about the user.
// picture: The picture claim provides a URL to the user's profile picture or avatar.
// website: This claim contains the URL of the user's website or homepage.
// email: The email claim represents the user's email address.
// email_verified: The email verified claim indicates whether the user's email address has been verified.
// gender: This claim specifies the gender or sex of the user.
// birthdate: The birthdate claim denotes the user's date of birth.
// zoneinfo: This claim represents the user's time zone or geographical region.
// locale: The locale claim indicates the user's preferred language and cultural preferences.
// phone_number: The phone number claim contains the user's phone number.
// phone_number_verified: The phone number verified claim indicates whether the user's phone number has been verified.
// address: This claim carries the user's postal address or parts of it.
// updated_at: The updated at claim represents the time when the user's information was last updated.